<template>
    <div id="zone-select-container">
        <VueSelect 
            label="name"
            v-bind="$attrs" 
            :options="zones" 
            @input="val => $emit('input', val)"
        >
            <template #option="zone">
                <span>
                    <i class="fa-solid fa-circle" :style="{ color: zone.color }"></i>
                    {{ zone.name }} {{ zone.extension !== '0' ? `( ${zone.extension} )` : '' }}
                </span>
            </template>
            <template #selected-option="zone">
                <span :title="zone.name">
                    <i class="fa-solid fa-circle" :style="{ color: zone.color }"></i>
                    {{ zone.name }} {{ zone.extension !== '0' ? `( ${zone.extension} )` : '' }}
                </span>
            </template>
        </VueSelect>
    </div>
</template>

<script>
import { VueSelect } from 'vue-select';

export default {
    inheritAttrs: false,
    components: { VueSelect },
    emits: ['input'],
    props: {
        zones: Array,
    }
}
</script>